<template>
  <div class="Trio-funnel-form">
    <form>
      <personal-form :is-valid-email="isValidEmail"></personal-form>
      <mortgage-form></mortgage-form>
      <check-box-form></check-box-form>
      <loader v-if="loading"></loader>
      <div v-else class="Trio-btn-row">
        <button-next
          :is-disabled="!isFullData || !isValidEmail || loading"
          @clicked="createMortgage"
        >
          Continuar
        </button-next>
      </div>
    </form>
  </div>
</template>

<script>
import { Store } from "../store/index";
import { mapActions, mapState } from "vuex";
import buttonNext from "./buttonNext.vue";
import personalForm from "./personalForm.vue";
import mortgageForm from "./mortgageForm.vue";
import checkBoxForm from "./checkBoxForm.vue";
import loader from "./loader.vue";

export default {
  name: "funnelForm",
  components: { buttonNext, personalForm, mortgageForm, checkBoxForm, loader },
  computed: {
    ...mapState("ui", ["loading"]),
    isFullData() {
      return (
        Store.getters["mortgageData/isFullMortgageData"] &&
        Store.getters["personalData/isFullPersonalData"]
      );
    },
    isValidEmail() {
      if (Store.getters["personalData/email"]) {
        return Store.getters["personalData/isValidEmail"];
      }
      return true;
    },
  },
  methods: {
    ...mapActions("locations", ["getLocations"]),
    ...mapActions("mortgageData", ["createMortgage"]),
  },
  created() {
    if (!Store.getters["locations/locations"]) {
      this.getLocations();
    }
  },
};
</script>